module.exports = __webpack_public_path__ + "static/media/7. Fracciones, Instalación, Resina epóxica y tela,  240 x 480 cm aproximado,2019 copy.10d9a3ef.png";